import "core-js/modules/es6.string.includes";
import "core-js/modules/es7.array.includes";
import "core-js/modules/es6.number.constructor";
import ListenersMixin from "./listeners.js";
var labelPositions = ['top', 'right', 'bottom', 'left'];
export default {
  mixins: [ListenersMixin],
  props: {
    type: {
      type: String,
      default: 'a'
    },
    outline: Boolean,
    push: Boolean,
    flat: Boolean,
    unelevated: Boolean,
    color: String,
    textColor: String,
    glossy: Boolean,
    square: Boolean,
    padding: String,
    label: {
      type: [String, Number],
      default: ''
    },
    labelPosition: {
      type: String,
      default: 'right',
      validator: function validator(v) {
        return labelPositions.includes(v);
      }
    },
    externalLabel: Boolean,
    hideLabel: {
      type: Boolean
    },
    labelClass: [Array, String, Object],
    labelStyle: [Array, String, Object],
    disable: Boolean,
    tabindex: [Number, String]
  },
  computed: {
    formClass: function formClass() {
      return "q-fab--form-".concat(this.square === true ? 'square' : 'rounded');
    },
    stacked: function stacked() {
      return this.externalLabel === false && ['top', 'bottom'].includes(this.labelPosition);
    },
    labelProps: function labelProps() {
      if (this.externalLabel === true) {
        var hideLabel = this.hideLabel === null ? this.showing === false : this.hideLabel;
        return {
          action: 'push',
          data: {
            staticClass: "q-fab__label q-tooltip--style q-fab__label--external" + " q-fab__label--external-".concat(this.labelPosition) + (hideLabel === true ? ' q-fab__label--external-hidden' : ''),
            style: this.labelStyle,
            class: this.labelClass
          }
        };
      }

      return {
        action: ['left', 'top'].includes(this.labelPosition) ? 'unshift' : 'push',
        data: {
          staticClass: "q-fab__label q-fab__label--internal q-fab__label--internal-".concat(this.labelPosition) + (this.hideLabel === true ? ' q-fab__label--internal-hidden' : ''),
          style: this.labelStyle,
          class: this.labelClass
        }
      };
    }
  }
};